import { IconPropsType } from '..';

export const InstantGameIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_14520_181937)">
      <path d="M7.02997 0.296555C7.26322 0.616444 7.18992 1.06295 6.87003 1.28954C5.31723 2.40915 4.75074 3.7487 5.17725 5.42145L7.37649 3.44213C7.66972 3.18222 8.11624 3.20222 8.38281 3.49545L9.80232 5.0749C12.1149 4.82166 14.5007 5.64803 16.1801 7.50739C18.9458 10.5797 18.6992 15.3114 15.627 18.0771C12.5547 20.8428 7.82301 20.5962 5.0573 17.5239C3.32457 15.6046 2.7781 13.0322 3.3579 10.6996L2.03167 9.22013C1.77176 8.9269 1.79177 8.48039 2.085 8.21382L4.02433 6.46775C3.09132 3.94196 3.75776 1.7827 6.03031 0.136607C6.3502 -0.0966459 6.79671 -0.0233343 7.0233 0.296555H7.02997ZM11.0752 6.70101C10.682 6.70101 10.3621 7.02089 10.3621 7.41409C10.3621 7.80729 10.682 8.12718 11.0752 8.12718C13.4344 8.12718 15.3537 10.0399 15.3537 12.4057C15.3537 12.7989 15.6736 13.1188 16.0668 13.1188C16.46 13.1188 16.7799 12.7989 16.7799 12.4057C16.7799 9.25346 14.2275 6.70101 11.0752 6.70101Z" />
    </g>
    <defs>
      <clipPath id="clip0_14520_181937">
        <rect
          width="20"
          height="20"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
